import layout from '@/layout'

const meta = {
  auth: true
}

export default {
  path: '/projectManagement',
  component: layout,
  children: ((pre) => [
    {
      path: 'projectCategory',
      name: `${pre}category`,
      meta: {
        ...meta,
        cache: true,
        title: '项目类别设置',
        head: true,
        funcID: 'T000701',
        PID: 'T00'
      },
      component: () => import('@/views/digital/projectManager/category')
    },
    {
      path: 'projectDictionary',
      name: `${pre}dictionary`,
      meta: {
        ...meta,
        cache: true,
        title: '项目属性设置',
        head: true,
        funcID: 'T000702',
        PID: 'T00'
      },
      component: () => import('@/views/digital/projectManager/dictionary')
    },
    {
      path: 'projectInputTemplate',
      name: `${pre}inputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '项目录入模板设置',
        head: true,
        funcID: 'T000703',
        PID: 'T00'
      },
      component: () => import('@/views/digital/projectManager/inputTemplate')
    },
    {
      path: 'projectTag',
      name: `${pre}tag`,
      meta: {
        ...meta,
        cache: true,
        title: '项目标签设置',
        head: true,
        funcID: 'T000704',
        PID: 'T00'
      },
      component: () => import('@/views/digital/projectManager/tag')
    },
    {
      path: 'projectInfo',
      name: `${pre}projectInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '项目管理',
        head: true,
        funcID: 'T000705',
        PID: 'T00'
      },
      component: () => import('@/views/digital/projectManager/info')
    },
    {
      path: 'projectInfo/edit/:pageType/:prjCode',
      name: `${pre}projectInfo-edit`,
      meta: {
        ...meta,
        cache: false,
        title: '项目详情编辑',
        funcID: 'T000705',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/projectManager/info/components/edit')
    },
    {
      path: 'projectInfo/detail/:pageType/:prjCode',
      name: `${pre}projectInfo-detail`,
      meta: {
        ...meta,
        cache: false,
        title: '项目详情查看',
        funcID: 'T000705',
        PID: 'T00'
      },
      component: () =>
        import('@/views/digital/projectManager/info/components/detail')
    }
  ])('projectManagement-')
}
